import { render, staticRenderFns } from "./el-transfer.vue?vue&type=template&id=5559151a&scoped=true&"
import script from "./el-transfer.vue?vue&type=script&lang=js&"
export * from "./el-transfer.vue?vue&type=script&lang=js&"
import style0 from "./el-transfer.vue?vue&type=style&index=0&id=5559151a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5559151a",
  null
  
)

export default component.exports